import { createContext, useContext } from "react";

const PdpDataContext = createContext(null);

export const PdpDataProvider = ({ data, children }) => (
  <PdpDataContext.Provider value={data}>{children}</PdpDataContext.Provider>
);

export const useProduct = () => {
  const ctx = useContext(PdpDataContext);
  if (!ctx) throw new Error("useProduct must be used within PdpDataProvider");
  return ctx;
};
